import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const OfferBanner = () => {
  const [offers, setOffers] = useState([]);

  const isDismissed = (id) =>
    sessionStorage.getItem(`dismiss_offer_${id}`) === 'true';

  const dismiss = (id) => {
    sessionStorage.setItem(`dismiss_offer_${id}`, 'true');
    setOffers((prev) => prev.filter((o) => o.id !== id));
  };

  useEffect(() => {
    // ✅ Fetch from public folder (works on localhost + production)
    fetch(`${process.env.PUBLIC_URL}/offers.json`)
      .then((res) => res.json())
      .then((data) => {
        const active = data.filter((offer) => offer.visible && !isDismissed(offer.id));
        setOffers(active);
      })
      .catch((err) => {
        console.error('OfferBanner: failed to load offers.json', err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (offers.length === 0) return null;

  return (
    <div className="w-full">
      {offers.map((offer) => (
        <div
          key={offer.id}
          className={`flex justify-center items-center px-4 py-2 text-sm font-semibold ${offer.bgColor} ${offer.textColor} text-center md:text-base`}
        >
          <div className="flex-1">
  {offer.link ? (
    <Link to={offer.link} className="hover:underline block md:inline">
      {/* ADDED "→ Explore Now" HERE */}
      {offer.message} → Explore Now
    </Link>
  ) : (
    <span>{offer.message}</span>
  )}
</div>

          {offer.dismissible && (
            <button
              onClick={() => dismiss(offer.id)}
              className="ml-3 text-xl font-bold text-gray-400 hover:text-gray-600"
              aria-label="Dismiss offer"
            >
              ×
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default OfferBanner;

// import React, { useState } from 'react';

// const OfferBanner = () => {
//   const [dismissed, setDismissed] = useState(false);

//   if (dismissed) return null;

//   return (
//     <div className="w-full bg-red-600 text-white flex justify-center items-center px-4 py-2 text-sm font-semibold text-center md:text-base">
//       <div className="flex-1">
//         ⚠️ Our site is currently experiencing technical issues and may be temporarily unavailable. We are working to resolve this as soon as possible. We apologize for the inconvenience.
//       </div>
//       <button
//         onClick={() => setDismissed(true)}
//         className="ml-3 text-xl font-bold text-white hover:text-gray-200"
//         aria-label="Dismiss alert"
//       >
//         ×
//       </button>
//     </div>
//   );
// };

// export default OfferBanner;